import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n";
import Logo from "@/components/site/Logo";

const PHONE = "+39 375 597 9360";
const EMAIL = "info@casaisolana.it";
const WHATSAPP = "https://wa.me/393755979360";

const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer data-testid="site-footer" className="bg-[#0D253A] text-[#F8F5F0] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Logo variant="dark" />
          <p className="mt-4 text-sm text-[#F8F5F0]/65 max-w-sm leading-relaxed">{t.footer.tagline}</p>
          <p className="mt-6 flex items-center gap-2 text-xs text-[#F8F5F0]/50">
            <MapPin className="w-4 h-4 text-[#C86D51]" />
            {t.footer.address}
          </p>
        </div>

        <div className="md:col-span-4">
          <h3 className="text-xs uppercase tracking-[0.25em] text-[#C86D51] font-semibold mb-5">{t.footer.contacts}</h3>
          <div className="flex flex-col gap-3 text-sm">
            <a data-testid="footer-phone" href={`tel:${PHONE.replace(/\s/g, "")}`} className="flex items-center gap-3 text-[#F8F5F0]/80 hover:text-[#C86D51] transition-colors">
              <Phone className="w-4 h-4" /> {PHONE}
            </a>
            <a data-testid="footer-email" href={`mailto:${EMAIL}`} className="flex items-center gap-3 text-[#F8F5F0]/80 hover:text-[#C86D51] transition-colors">
              <Mail className="w-4 h-4" /> {EMAIL}
            </a>
            <a
              data-testid="footer-whatsapp"
              href={WHATSAPP}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 inline-flex w-fit items-center gap-2 px-5 py-2.5 rounded-full bg-[#C86D51] text-white text-xs font-semibold hover:bg-[#F8F5F0] hover:text-[#0D253A] transition-colors duration-300"
            >
              <MessageCircle className="w-4 h-4" /> {t.footer.whatsapp}
            </a>
          </div>
        </div>

        <div className="md:col-span-3 flex flex-col justify-between">
          <p className="font-display italic text-lg text-[#F8F5F0]/70">"Il mare, una volta che ti getta il suo incantesimo, ti tiene per sempre nella sua rete di meraviglia."</p>
          <p className="text-xs text-[#F8F5F0]/40 mt-6">© {new Date().getFullYear()} Casa Isolana. {t.footer.rights}</p>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 py-5 flex flex-wrap gap-x-6 gap-y-2 text-xs text-[#F8F5F0]/50">
          <Link data-testid="footer-privacy-link" to="/privacy" className="hover:text-[#C86D51] transition-colors">{t.legal.privacy}</Link>
          <Link data-testid="footer-cookie-link" to="/cookie-policy" className="hover:text-[#C86D51] transition-colors">{t.legal.cookie}</Link>
          <Link data-testid="footer-terms-link" to="/termini" className="hover:text-[#C86D51] transition-colors">{t.legal.terms}</Link>
          <Link data-testid="footer-guide-link" to="/guida" className="hover:text-[#C86D51] transition-colors">{t.guide.eyebrow}</Link>
          <Link data-testid="footer-gift-link" to="/regalo" className="hover:text-[#C86D51] transition-colors">{t.gift.nav}</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
